import { useLocation } from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { getHomeImages, deleteHomeImage } from "../../actions/HomePageImages";
import React, { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../../path";

function ViewHome() {
    type HomeImage = {
        id: number;
        title: string;
        link: string;
        image_path: string;
        mobile_image_path: string;
        display_order: number;
    };

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [homeImages, setHomeImages] = useState<HomeImage[]>([]);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const location = useLocation();
    const user = location.state?.user;

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    useEffect(() => {
        fetchHomeImages();
    }, []);

    const fetchHomeImages = () => {
        getHomeImages()
            .then(response => {
                setHomeImages(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch home images:", error);
                setErrorMessage("Failed to load home images.");
            });
    };

    const deleteImage = async (e: React.MouseEvent, id: number) => {
        e.preventDefault();
        setSuccessMessage(null);
        setErrorMessage(null);

        try {
            const response = await deleteHomeImage(id);
            if (response.status === 201) {
                setSuccessMessage("Image deleted successfully.");
                fetchHomeImages();
            } else {
                setErrorMessage("Failed to delete image.");
            }
        } catch (err) {
            console.error("Error deleting image:", err);
            setErrorMessage("An error occurred while deleting the image.");
        }

        // Auto-hide messages after 5 seconds
        setTimeout(() => {
            setSuccessMessage(null);
            setErrorMessage(null);
        }, 5000);
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="content-form-button right-align">
                    <button
                        type="button"
                        className="button button-right"
                        onClick={() => navigate('/dashboard/home/add-home-images', { state: { user } })}
                    >
                        Add New Home Page Image
                    </button>
                </div>

                {/* Success or Error Message */}
                {(successMessage || errorMessage) && (
                    <div style={{ marginBottom: '15px' }}>
                        {successMessage && <div className="alert success">{successMessage}</div>}
                        {errorMessage && <div className="alert error">{errorMessage}</div>}
                    </div>
                )}

                <div className="table-container">
                    <table className="home-images-table">
                        <thead>
                            <tr>
                                <th style={{ width: "30%" }}>Title</th>
                                <th style={{ width: "13%" }}>Image</th>
                                <th style={{ width: "7%" }}>Mobile Image</th>
                                <th style={{ width: "15%" }}>Path</th>
                                <th style={{ width: "10%" }}>Display Order</th>
                                <th style={{ width: "15%" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {homeImages.length > 0 ? (
                                homeImages.map((image, index) => (
                                    <tr key={index}>
                                        <td>{image.title}</td>
                                        <td><img src={IMAGE_URL + image.image_path} alt={image.title} style={{ width: '200px' }} /></td>
                                        <td><img src={IMAGE_URL  + image.mobile_image_path} alt={image.title} style={{ width: '80px' }} /></td>
                                        <td>{image.link}</td>
                                        <td>{image.display_order}</td>
                                        <td>
                                            <button
                                                className="button small"
                                                onClick={() => navigate('/dashboard/home/edit-home-images', { state: { user, image } })}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="button small danger"
                                                style={{ marginLeft: "10px" }}
                                                onClick={(e) => deleteImage(e, image.id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6}>No home page images found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ViewHome;
